export default {
  columns: {
    offerName: 'Nome da oferta',
    type: 'Tipo',
    status: 'Estado',
    active: 'Ativo',
    inactive: 'Inativo',
    details: 'Detalhes',
    schedule: 'Horário',
    startDate: 'Data de início',
    images: 'Imagem',
  },
  actions: {
    edit: 'Editar',
    rename: 'Renomear',
    delete: 'Eliminar',
    set_active: 'Definir como ativo',
    set_inactive: 'Definir como inativo',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    activate: 'Substituir e Ativar',
    manage_images: 'Editar Imagem',
  },
  toasts: {
    offer_enabled: '{{offer}} é agora a oferta ativa para {{for}}',
    offer_disabled: '{{offer}} definida como Inativa.',
    update_failed: 'A atualização da oferta falhou.',
    successfully_deleted: 'A oferta foi eliminada com sucesso',
    delete_failed: 'A eliminação da oferta falhou',
  },
  title: 'Gerir Todas as Ofertas',
  popups: {
    delete: {
      title: 'Tem a certeza de que pretende eliminar esta oferta?',
    },
    toggle: {
      title_overlapping_is_not_allowed: 'Substituir ofertas principais não é permitido',
      title: 'Substituir a oferta ativa neste período?',
      description:
        'Está a ativar {{offer}} em {{weekday}}{{between}}. Isto irá desativar a oferta ativa atual {{currentOffer}} para o mesmo período.',
      between: ', entre {{start}}-{{end}}',
    },
  },
};
